<template>
<div class="nrs-main-view">

    <div class="nrs-container">

        <div class="nrs-page-header" style="margin-bottom: 5px;">
            {{L('PrivacyPolicy.Title.Page')}}
        </div>

        <p v-if="L('PrivacyPolicy.LanguageDisclaimer')">
            {{L('PrivacyPolicy.LanguageDisclaimer')}}
        </p>

        <div class="nrs-page-header" style="margin-bottom: 0;">
            {{L('PrivacyPolicy.LastUpdatedDate')}}
        </div>

        <div class="nrs-page-body">

            <p>
                {{L('PrivacyPolicy.Section0.Paragraph1.SubSection1')}}<strong>{{L('PrivacyPolicy.Section0.Paragraph1.SubSection2Bold')}}</strong>{{L('PrivacyPolicy.Section0.Paragraph1.SubSection3')}}<strong>{{L('PrivacyPolicy.Section0.Paragraph1.SubSection4Bold')}}</strong>{{L('PrivacyPolicy.Section0.Paragraph1.SubSection5')}}<strong>{{L('PrivacyPolicy.Section0.Paragraph1.SubSection6Bold')}}</strong>{{L('PrivacyPolicy.Section0.Paragraph1.SubSection7')}}<strong>{{L('PrivacyPolicy.Section0.Paragraph1.SubSection8Bold')}}</strong>{{L('PrivacyPolicy.Section0.Paragraph1.SubSection9')}}{{L('PrivacyPolicy.Section0.Paragraph1.SubSection10')}}{{L('PrivacyPolicy.Section0.Paragraph1.SubSection11')}}
            </p>
                {{L('PrivacyPolicy.Section0.Paragraph2.SubSection1')}}<strong>{{L('PrivacyPolicy.Section0.Paragraph2.SubSection2Bold')}}</strong>{{L('PrivacyPolicy.Section0.Paragraph2.SubSection3')}}

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section1')}}</div>

            <p>
                {{L('PrivacyPolicy.Section1.Paragraph1.SubSection1')}}<strong>{{L('PrivacyPolicy.Section1.Paragraph1.SubSection2Bold')}}</strong>{{L('PrivacyPolicy.Section1.Paragraph1.SubSection3')}}<strong>{{L('PrivacyPolicy.Section1.Paragraph1.SubSection4Bold')}}</strong>{{L('PrivacyPolicy.Section1.Paragraph1.SubSection5')}}<a target="_blank" v-bind:href="nrsDpaUrl">{{nrsDpaUrl}}</a>{{L('PrivacyPolicy.Section1.Paragraph1.SubSection6')}}

            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section2.SectionHeader')}}</div>

            <div class="nrs-page-sub-section-header">{{L('PrivacyPolicy.Title.Section2.SubSection1')}}</div>

            <p>
                {{L('PrivacyPolicy.Section2.Paragraph1')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section2.Paragraph2')}}
            </p>

            <div class="nrs-page-sub-section-header">{{L('PrivacyPolicy.Title.Section2.SubSection2')}}</div>

            <p>
                {{L('PrivacyPolicy.Section2.Paragraph3')}}
            </p>

            <div class="nrs-page-sub-section-header">{{L('PrivacyPolicy.Title.Section2.SubSection3')}}</div>

            <p>
                {{L('PrivacyPolicy.Section2.Paragraph4')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section2.Paragraph5.SubSection1')}}<a target="_blank" href="https://policies.google.com/technologies/partner-sites">{{L('PrivacyPolicy.Section2.Paragraph5.SubSection2Link')}}</a>{{L('PrivacyPolicy.Section2.Paragraph5.SubSection3')}}<a target="_blank" href="https://tools.google.com/dlpage/gaoptout/">{{L('PrivacyPolicy.Section2.Paragraph5.SubSection4Link')}}</a>{{L('PrivacyPolicy.Section2.Paragraph5.SubSection5')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section2.Paragraph6.SubSection1')}}<a target="_blank" href="https://www.fullstory.com/legal/privacy">{{L('PrivacyPolicy.Section2.Paragraph6.SubSection2Link')}}</a>{{L('PrivacyPolicy.Section2.Paragraph6.SubSection3')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section2.Paragraph7.SubSection1')}}<a target="_blank" href="https://www.fullstory.com/optout">{{L('PrivacyPolicy.Section2.Paragraph7.SubSection2Link')}}</a>{{L('PrivacyPolicy.Section2.Paragraph7.SubSection3')}}<a target="_blank" href="https://www.fullstory.com/optout">{{L('PrivacyPolicy.Section2.Paragraph7.SubSection4Link')}}</a>{{L('PrivacyPolicy.Section2.Paragraph7.SubSection5')}}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section3')}}</div>

            <p>
                {{L('PrivacyPolicy.Section3.Paragraph1')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section3.Paragraph2')}}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section4')}}</div>

            <p>
                {{L('PrivacyPolicy.Section4.Paragraph1.SubSection1')}}<strong>{{L('PrivacyPolicy.Section4.Paragraph1.SubSection2Bold')}}</strong>{{L('PrivacyPolicy.Section4.Paragraph1.SubSection3')}}<strong>{{L('PrivacyPolicy.Section4.Paragraph1.SubSection4Bold')}}</strong>{{L('PrivacyPolicy.Section4.Paragraph1.SubSection5')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section4.Paragraph2.SubSection1')}}<strong>{{L('PrivacyPolicy.Section4.Paragraph2.SubSection2Bold')}}</strong>{{L('PrivacyPolicy.Section4.Paragraph2.SubSection3')}}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section5')}}</div>

            <p>
                {{L('PrivacyPolicy.Section5.Paragraph1.SubSection1')}}<a target="_blank" href="mailto:chiefprivacyofficer@netroadshow.com">chiefprivacyofficer@netroadshow.com</a>{{L('PrivacyPolicy.Section5.Paragraph1.SubSection2')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section5.Paragraph2.SubSection1')}}<a target="_blank" href="mailto:chiefprivacyofficer@netroadshow.com">chiefprivacyofficer@netroadshow.com</a>{{L('PrivacyPolicy.Section5.Paragraph2.SubSection2')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section5.Paragraph3.SubSection1')}}<a target="_blank" href="mailto:chiefprivacyofficer@netroadshow.com">chiefprivacyofficer@netroadshow.com</a>{{L('PrivacyPolicy.Section5.Paragraph3.SubSection2')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section5.Paragraph4.SubSection1')}}<a target="_blank" href="https://www.jamsadr.com/DPF-Dispute-Resolution">https://www.jamsadr.com/DPF-Dispute-Resolution</a>{{ L('PrivacyPolicy.Section5.Paragraph4.SubSection2') }}
            </p>

            <p>
                {{L('PrivacyPolicy.Section5.Paragraph5.SubSection1')}}<a target="_blank" href="https://www.dataprivacyframework.gov/framework-article/ANNEX-I-introduction">{{ L('PrivacyPolicy.Section5.Paragraph5.LinkText') }}</a>{{ L('PrivacyPolicy.Section5.Paragraph5.SubSection2') }}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section6')}}</div>

            <p>
                {{L('PrivacyPolicy.Section6.Paragraph1')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section6.Paragraph2')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section6.Paragraph3')}}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section7')}}</div>

            <p>
                {{L('PrivacyPolicy.Section7.Paragraph1')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section7.Paragraph2')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section7.Paragraph3')}}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section8')}}</div>

            <p>
                {{L('PrivacyPolicy.Section8.Paragraph1')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section8.Paragraph2')}}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section9')}}</div>

            <p>
                {{L('PrivacyPolicy.Section9.Paragraph1')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section9.Paragraph2')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section9.Paragraph3')}}
            </p>

            <ul>
                <li>{{L('PrivacyPolicy.Section9.Paragraph4.SubSection1')}}</li>

                <li>{{L('PrivacyPolicy.Section9.Paragraph4.SubSection2')}}</li>
                
                <li>{{L('PrivacyPolicy.Section9.Paragraph4.SubSection3')}}</li>
            </ul>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section10')}}</div>

            <p>
                {{L('PrivacyPolicy.Section10.Paragraph1')}}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section11')}}</div>

            <p>
                {{L('PrivacyPolicy.Section11.Paragraph1')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section11.Paragraph2')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section11.Paragraph3')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section11.Paragraph4.SubSection1')}}<a target="_blank" href="mailto:chiefprivacyofficer@netroadshow.com">chiefprivacyofficer@netroadshow.com</a>{{L('PrivacyPolicy.Section11.Paragraph4.SubSection2')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section11.Paragraph5.SubSection1')}}<a target="_blank" href="https://ico.org.uk/your-data-matters/">https://ico.org.uk/your-data-matters/</a>{{L('PrivacyPolicy.Section11.Paragraph5.SubSection2')}}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section12')}}</div>

            <p>
                {{L('PrivacyPolicy.Section12.Paragraph1')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section12.Paragraph2')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section12.Paragraph3.SubSection1')}}<a target="_blank" href="mailto:chiefprivacyofficer@netroadshow.com">chiefprivacyofficer@netroadshow.com</a>{{L('PrivacyPolicy.Section12.Paragraph3.SubSection2')}}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section13')}}</div>

            <p>
                <table class="nrs-privacy-policy-table" aria-describedby="Third Party Processors">
                    <tr>
                        <th>{{L('PrivacyPolicy.Section13.Table.Headers.ServiceName')}}</th>
                        <th>{{L('PrivacyPolicy.Section13.Table.Headers.Purpose')}}</th>
                        <th>{{L('PrivacyPolicy.Section13.Table.Headers.EntityCountry')}}</th>
                        <th>{{L('PrivacyPolicy.Section13.Table.Headers.Website')}}</th>
                        <!-- Because sonar qube wants all th elements to have a unique id...... -->
                        <th id="9831274982347">{{L('PrivacyPolicy.Section13.Table.Headers.NRSProduct')}}</th>
                    </tr>
                    <tr>
                        <td>Amazon AWS</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Amazon.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Amazon.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="https://aws.amazon.com/">https://aws.amazon.com/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Amazon.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>Mailgun</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Mailgun.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Mailgun.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="https://www.mailgun.com/">https://www.mailgun.com/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Mailgun.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>DataValidation</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.DataValidation.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.DataValidation.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="https://www.datavalidation.com/">https://www.datavalidation.com/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.DataValidation.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>Twilio</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Twilio.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Twilio.EntityCountry')}}</td>
                        <td>
                          <a target="_blank" rel="noopener noreferrer" ref="https://www.twilio.com/">https://www.twilio.com/</a>
                          <br/>
                          <a target="_blank" rel="noopener noreferrer" ref="https://www.sendgrid.com/">https://www.sendgrid.com/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Twilio.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>{{L('PrivacyPolicy.Section13.Table.GoogleAnalytics.ServiceName')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.GoogleAnalytics.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.GoogleAnalytics.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="https://marketingplatform.google.com/about/analytics/">https://marketingplatform.google.com/about/analytics/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.GoogleAnalytics.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>Fullstory</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Fullstory.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Fullstory.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="https://www.fullstory.com/">https://www.fullstory.com/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Fullstory.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>Lindenbaum GmbH</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Lindenbaum.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Lindenbaum.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="https://www.lindenbaum.eu/">https://www.lindenbaum.eu/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Lindenbaum.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>Zoom</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Zoom.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Zoom.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="https://zoom.us/">https://zoom.us/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Zoom.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>Domo</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Domo.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Domo.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="https://www.domo.com/">https://www.domo.com</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Domo.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>Hubspot</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Hubspot.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Hubspot.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="https://www.hubspot.com/">https://www.hubspot.com/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Hubspot.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>Salesforce</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Salesforce.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Salesforce.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="http://www.salesforce.com/">http://www.salesforce.com/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Salesforce.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>Way With Words</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.WayWithWords.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.WayWithWords.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="http://www.waywithwords.net/">http://www.waywithwords.net/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.WayWithWords.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>Rev</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Rev.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Rev.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="https://www.rev.com/">https://www.rev.com/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.Rev.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>TTE Transcripts Worldwide</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.TTE.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.TTE.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" href="http://www.ttetranscripts.com/">http://www.ttetranscripts.com/</a>
                        </td>
                        <td>{{L('PrivacyPolicy.Section13.Table.TTE.NRSProduct')}}</td>
                    </tr>
                    <tr>
                        <td>hCaptcha</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.hCaptcha.Purpose')}}</td>
                        <td>{{L('PrivacyPolicy.Section13.Table.hCaptcha.EntityCountry')}}</td>
                        <td>
                            <a target="_blank" :href="L('PrivacyPolicy.Section13.Table.hCaptcha.Website')">{{ L('PrivacyPolicy.Section13.Table.hCaptcha.Website') }}</a>
                        </td>
                        <td>{{ L('PrivacyPolicy.Section13.Table.hCaptcha.NRSProduct') }}</td>
                    </tr>
                </table>
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section14')}}</div>

            <p>
                {{L('PrivacyPolicy.Section14.Paragraph1.SubSection1')}}<a target="_blank" href="https://www.dataprivacyframework.gov/">https://www.dataprivacyframework.gov/</a>{{L('PrivacyPolicy.Section14.Paragraph1.SubSection2')}}
            </p>

            <p>
                {{L('PrivacyPolicy.Section14.Paragraph2')}}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section15')}}</div>

            <p>
                {{L('PrivacyPolicy.Section15.Paragraph1')}}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section16')}}</div>

            <p>
                <strong>{{L('PrivacyPolicy.Section16.Definition1.Term')}}</strong>{{L('PrivacyPolicy.Section16.Definition1.Definition')}}
            </p>

            <p>
                <strong>{{L('PrivacyPolicy.Section16.Definition2.Term')}}</strong>{{L('PrivacyPolicy.Section16.Definition2.Definition')}}
            </p>

            <p>
                <strong>{{L('PrivacyPolicy.Section16.Definition3.Term')}}</strong>{{L('PrivacyPolicy.Section16.Definition3.Definition')}}
            </p>

            <p>
                <strong>{{L('PrivacyPolicy.Section16.Definition4.Term')}}</strong>{{L('PrivacyPolicy.Section16.Definition4.Definition')}}
            </p>

            <div class="nrs-page-sub-header">{{L('PrivacyPolicy.Title.Section17')}}</div>

            <p>
                {{L('PrivacyPolicy.Section17.Paragraph1.SubSection1')}}<a target="_blank" href="mailto:chiefprivacyofficer@netroadshow.com">chiefprivacyofficer@netroadshow.com</a>{{L('PrivacyPolicy.Section17.Paragraph1.SubSection2')}}
            </p>

        </div>

    </div>

</div>
</template>

<script>
import { L, polyglot } from '../modules/translate';
import Constants from '../modules/constants';

export default {
  name: 'PrivacyPolicy',
  data() {
    const nrsDpaUrl = `${process.env.VUE_APP_NRS_URL
        + Constants.UrlEndings.NrsHome
        + polyglot.locale()}/${Constants.UrlEndings.DataProcessingAddendum}`;
    return {
      L,
      nrsDpaUrl,
    };
  },
};
</script>


<style lang="less" scoped>
*, :before, :after {
    box-sizing: border-box;
}

a {
    color: #337ab7;
    text-decoration: none;
}

.nrs-container {
    max-width: 970px;
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    padding-right: 15px;
}

.nrs-container {
    display: table;
    padding-left: 5px;
    position: relative;
}

.nrs-main-view {
    padding-top: 88px;
    padding-bottom: 50px;
}

.nrs-main-view .nrs-container {
    justify-content: center;
}

.nrs-page-header {
    font-size: 24px;
    font-weight: 500;
    color: #285298;
    padding-bottom: 3px;
    margin-bottom: 15px;
}

.nrs-page-body {
    padding-bottom: 30px;
    line-height: 1.75;
}

.nrs-page-sub-header {
    font-size: 18px;
    font-weight: 700;
    color: #285298;
    padding-bottom: 5px;
    margin-top: 30px;
    margin-bottom: -10px;
}

.nrs-page-sub-section-header{
    color: #2f5496;
    font-size: 16px;
    margin-bottom: -10px;
    margin-top: 15px;
}

.nrs-privacy-policy-table {
    overflow-x: auto;
    border-collapse: collapse;
    text-align: center;
    width: 100%;
}

.nrs-privacy-policy-table th {
    color: #285298;
    font-size: 15px;
}

.nrs-privacy-policy-table th,
.nrs-privacy-policy-table td {
    border: 1px solid #333;
    padding: 5px;
}

@media (max-width: 767px) {
    .nrs-privacy-policy-table {
        display: block;
    }
}
</style>
